<template>
  <div class="tutorial-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <router-link to="/tutorial">教程中心</router-link>
      <span class="separator"> &gt; </span>
      <span class="current-brand">{{ brandTitle }}</span>
    </div>

    <!-- 排序控制区 -->
    <div class="sort-section">
      <el-select 
        v-model="sortOrder" 
        placeholder="请选择排序方式" 
        class="sort-select"
        size="small"
        @change="handleSortChange"
      >
        <el-option
          v-for="item in sortOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>

    <!-- 教程列表 -->
    <div 
      class="tutorial-list"
      v-loading="newsLoading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)"
    >
      <!-- 教程项 - 使用灰色分割线 -->
      <div 
        v-for="(item, index) in newsContent" 
        :key="item.id" 
        class="tutorial-item"
        :class="{ 'last-item': index === newsContent.length - 1 }"
      >
        <h3 class="tutorial-title" @click="contentPage(item.id)">{{ item.title }}</h3>
        <p class="tutorial-description">{{ item.description }}</p>
        <div class="tutorial-meta">
          <span class="author">{{ $t('common.Author') }}：{{ item.author }}</span>
          <span class="create-time">{{ item.createTime }}</span>
          <span class="views">{{ $t('common.Views') }}：{{ item.hits }}</span>
        </div>
      </div>
    </div>

    <!-- 分页栏 -->
    <div class="pagination-container">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="number"
        :page-size="size"
        :layout="'total, prev, pager, next, jumper'"
        :total="totalElements"
        background
        :pager-count="5"
        :prev-text="'上一页'"
        :next-text="'下一页'"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  name: "tutorialClass",
  props: ['url', 'tutorialUri'],
  data() {
    return {
      language: this.$store.state.lang,
      newsLoading: true,      // 加载状态
      newsContent: [],        // 教程列表数据（当前页）
      allNewsContent: [],     // 所有页的教程列表数据
      totalElements: 0,       // 总条数
      totalPages: 0,          // 总页数
      size: 10,               // 每页显示10个教程
      number: 1,              // 当前页码
      brandTitle: '',         // 品牌标题
      sortOrder: 'desc',      // 默认按发布时间倒序
      sortOptions: [
        { value: 'desc', label: '按发布时间倒序' },
        { value: 'asc', label: '按发布时间升序' }
      ]
    }
  },
  
  created() {
    this.getNewsList();
  },
  
  methods: {
    // 获取所有教程列表数据
    getAllNewsList() {
      this.newsLoading = true;
      
      const lang = this.$store.state.lang;
      const url = this.$route.query.url || this.url;
      
      // 构建API请求URL，根据用户提供的旧代码，API可能不需要size参数
      // 移除size参数，使用API默认的分页大小
      let apiUrl = '';
      
      if (lang === 'zh') {
        apiUrl = `article/classificationChinaUri?type=2&uri=${url}&page=1`;
      } else {
        apiUrl = `article/classificationEnglishUri?type=2&uri=${url}&page=1`;
      }
      
      console.log('首次请求URL:', apiUrl);
      
      // 首先请求第一页数据
      axios.get(this.$store.state.apiBasePath + apiUrl)
        .then(res => {
          console.log('首次请求返回:', res.data);
          
          if (res.data.code === 200 && res.data.data && res.data.data.list && res.data.data.list.length > 0) {
            const resData = res.data.data;
            const listData = resData.list[0];
            
            // 获取第一页数据
            let allData = listData.tarticlesList || [];
            console.log('第一页数据数量:', allData.length);
            
            // 设置品牌标题
            this.brandTitle = lang === 'zh' ? listData.name : listData.enName;
            
            // 开始递归请求所有剩余数据，最多尝试20页，避免无限循环
            this.fetchRemainingPages(lang, url, 2, allData, 1, 20);
          } else {
            // 无数据情况
            this.allNewsContent = [];
            this.newsContent = [];
            this.totalElements = 0;
            this.totalPages = 0;
            this.number = 1;
            this.newsLoading = false;
          }
        })
        .catch(error => {
          console.error('获取第一页数据失败：', error);
          this.allNewsContent = [];
          this.newsContent = [];
          this.totalElements = 0;
          this.totalPages = 0;
          this.number = 1;
          this.newsLoading = false;
        });
    },
    
    // 递归请求剩余页数据，添加最大页数限制
    fetchRemainingPages(lang, url, currentPage, allData, pageCount, maxPages) {
      // 如果已经尝试了最大页数，停止请求
      if (pageCount >= maxPages) {
        console.log('已达到最大请求页数，停止请求');
        this.processAllData(allData);
        return;
      }
      
      let apiUrl = '';
      
      if (lang === 'zh') {
        apiUrl = `article/classificationChinaUri?type=2&uri=${url}&page=${currentPage}`;
      } else {
        apiUrl = `article/classificationEnglishUri?type=2&uri=${url}&page=${currentPage}`;
      }
      
      console.log('请求第', currentPage, '页:', apiUrl);
      
      axios.get(this.$store.state.apiBasePath + apiUrl)
        .then(res => {
          console.log('第', currentPage, '页返回:', res.data);
          
          if (res.data.code === 200 && res.data.data && res.data.data.list && res.data.data.list.length > 0) {
            const resData = res.data.data;
            const listData = resData.list[0];
            const pageData = listData.tarticlesList || [];
            
            if (pageData.length > 0) {
              // 合并当前页数据
              allData = allData.concat(pageData);
              console.log('第', currentPage, '页数据数量:', pageData.length, '累计数据数量:', allData.length);
              
              // 继续请求下一页，增加页数计数
              this.fetchRemainingPages(lang, url, currentPage + 1, allData, pageCount + 1, maxPages);
            } else {
              // 没有更多数据，处理最终结果
              this.processAllData(allData);
            }
          } else {
            // 请求失败或没有数据，处理最终结果
            this.processAllData(allData);
          }
        })
        .catch(error => {
          console.error('请求第', currentPage, '页失败:', error);
          // 请求失败，处理最终结果
          this.processAllData(allData);
        });
    },
    
    // 处理所有数据
    processAllData(allData) {
      // 设置所有数据
      this.allNewsContent = allData;
      console.log('最终获取到的所有数据数量:', this.allNewsContent.length);
      
      // 更新总条数和总页数
      this.totalElements = this.allNewsContent.length;
      this.totalPages = this.totalElements > 0 ? Math.ceil(this.totalElements / this.size) : 0;
      
      console.log('计算的总页数:', this.totalPages);
      
      // 对所有数据进行排序
      this.sortAllNewsContent();
      
      this.newsLoading = false;
    },
    
    // 对所有数据进行排序
    sortAllNewsContent() {
      // 对所有数据进行排序
      this.allNewsContent.sort((a, b) => {
        const timeA = new Date(a.createTime).getTime();
        const timeB = new Date(b.createTime).getTime();
        // 根据sortOrder决定排序顺序
        return this.sortOrder === 'desc' ? timeB - timeA : timeA - timeB;
      });
      
      // 更新当前页数据
      this.updateCurrentPageData();
    },
    
    // 更新当前页数据
    updateCurrentPageData() {
      // 计算当前页的起始和结束索引
      const startIndex = (this.number - 1) * this.size;
      const endIndex = startIndex + this.size;
      
      // 截取当前页数据
      this.newsContent = this.allNewsContent.slice(startIndex, endIndex);
      console.log('当前页教程数量:', this.newsContent.length);
    },
    
    // 获取教程列表数据（当前页）
    getNewsList(currentPage = 1) {
      this.newsLoading = true;
      
      // 如果还没有加载所有数据，则先加载所有数据
      if (this.allNewsContent.length === 0) {
        this.getAllNewsList();
      } else {
        // 已经加载了所有数据，直接更新当前页
        this.number = currentPage;
        this.updateCurrentPageData();
        this.newsLoading = false;
      }
    },
    
    // 切换页码时触发
    handleCurrentChange(currentPage) {
      // 确保页码在有效范围内
      let validPage = currentPage;
      if (validPage < 1) validPage = 1;
      if (this.totalPages > 0 && validPage > this.totalPages) validPage = this.totalPages;
      
      this.number = validPage;
      // 滚动到页面顶部
      window.scrollTo(0, 0);
      // 更新当前页数据
      this.updateCurrentPageData();
    },
    
    // 切换排序方式时触发
    handleSortChange() {
      this.number = 1; // 重置为第一页
      // 对所有数据重新排序
      this.sortAllNewsContent();
    },
    
    // 跳转到教程详情页
    contentPage(id) {
      const routeData = this.$router.resolve({ path: `/contentPage/${id}` });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>
/* 主容器样式 */
.tutorial-container {
  max-width: 1170px;
  margin: 0 auto;
  padding: 20px 0;
}

/* 面包屑导航 */
.breadcrumb {
  margin-bottom: 30px;
  font-size: 16px;
  color: #666;
}

.breadcrumb a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #00af42;
}

.current-brand {
  color: #00af42;
  font-weight: 500;
}

.separator {
  color: #999;
  margin: 0 8px;
}

/* 排序区域 */
.sort-section {
  margin-bottom: 20px;
}

.sort-select {
  width: 180px;
  font-size: 14px;
}

/* 教程列表 */
.tutorial-list {
  margin-bottom: 30px;
}

/* 教程项 - 实现灰色分割线 */
.tutorial-item {
  position: relative;
  padding: 20px 0;
}

/* 为除最后一项外的所有项添加灰色分割线 */
.tutorial-item:not(.last-item)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #e6e6e6;
}

.tutorial-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
  cursor: pointer;
  transition: color 0.3s ease;
}

.tutorial-title:hover {
  color: #00af42;
}

.tutorial-description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

/* 教程元信息 */
.tutorial-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 13px;
  color: #999;
}

.tutorial-meta .author {
  color: #009688;
}

/* 分页容器 - 放在最下面 */
.pagination-container {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .tutorial-container {
    padding: 15px;
  }
  
  .breadcrumb {
    margin-bottom: 20px;
    font-size: 14px;
  }
  
  .tutorial-title {
    font-size: 16px;
  }
  
  .tutorial-meta {
    font-size: 12px;
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .breadcrumb {
    font-size: 12px;
  }
  
  .separator {
    margin: 0 4px;
  }
  
  .sort-select {
    width: 100%;
  }
  
  .tutorial-description {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tutorialList/tutorialClass.vue